{
  "availability": "Maandag t/m vrijdag van 8:30 tot 17:00 uur",
  "facebook_messenger": "Facebook Messenger",
  "inselhuepfen": {
    "availability": "Wij zijn beschikbaar van maandag t/m vrijdag van 9:00 tot 12:00 uur en 14:00 tot 17:00 uur",
    "faqs": "Onze FAQ's",
    "faqs_url": "https://www.inselhuepfen.com/en/good-to-know",
    "phone_numbers": "+49 (0) 7531 / 361860",
    "send_us_a_message_url": "https://www.inselhuepfen.com/en/contact",
    "title": "Nog vragen?"
  },
  "phone_numbers": "+31 20 72 35 400 (NL)",
  "send_us_a_message": "Stuur ons een bericht",
  "send_us_a_message_url": "https://www.boatbiketours.nl/contact/#contact_form",
  "start_a_live_chat": "Begin live-chat",
  "title": "Vragen?"
}
